module.exports = __webpack_public_path__ + "media/maroon-5.5cef6d30.mp3";